import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { SendIcon, CheckCircle2Icon } from 'lucide-react';
export function ScheduleFormSection() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real app, this would send the data to a server
    setIsSubmitted(true);
    setTimeout(() => setIsSubmitted(false), 5000);
  };
  return <section id="schedule" className="w-full bg-nfblue-dark py-16 sm:py-24" data-id="element-296" data-mp="2kzvplprkkbuv">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8" data-id="element-297" data-mp="2g1c39o92cy1z">
        <div className="text-center" data-id="element-298" data-mp="2uxjmomcndvg7">
          <h2 className="font-display text-3xl font-extrabold text-white sm:text-4xl" data-id="element-299" data-mp="2uykvek66y5ur">
            Schedule a Diagnostic
          </h2>
          <p className="mt-4 text-lg text-slate-300" data-id="element-300" data-mp="2q0jf2705gkmz">
            Fill out the form below and our team will quickly reach out to confirm your appointment.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mt-10 rounded-3xl bg-white p-6 shadow-2xl sm:p-10" data-id="element-301" data-mp="57pnu9btuwsj">
          {isSubmitted ? <div className="flex flex-col items-center justify-center py-12 text-center" data-id="element-302" data-mp="2b831ss75rohs">
              <div className="flex h-20 w-20 items-center justify-center rounded-full bg-nfgreen/10 text-nfgreen" data-id="element-303" data-mp="2f7vhrpyvswx6">
                <CheckCircle2Icon className="h-10 w-10" data-id="element-304" data-mp="1ikqsvktx7f6y" />
              </div>
              <h3 className="mt-6 font-display text-2xl font-bold text-slate-900" data-id="element-305" data-mp="1nisb63jivahd">
                Request Sent Successfully
              </h3>
              <p className="mt-2 text-slate-600" data-id="element-306" data-mp="1rhrbfaub6j2h">
                Thank you for reaching out. We will contact you shortly to confirm your appointment time.
              </p>
            </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-307" data-mp="13tzz478rq617">
              <div className="grid gap-6 sm:grid-cols-2" data-id="element-308" data-mp="13s6sgry5nlt7">
                <div data-id="element-309" data-mp="2745gr14jok9b">
                  <label htmlFor="firstName" className="block text-sm font-bold text-slate-700" data-id="element-310" data-mp="273m8kc4p5a8h">
                    First name <span className="text-red-500" data-id="element-311" data-mp="225ayq1eeizq9">*</span>
                  </label>
                  <input type="text" id="firstName" required className="mt-2 block w-full rounded-xl border border-slate-300 px-4 py-3 text-slate-900 placeholder-slate-400 focus:border-nfblue focus:outline-none focus:ring-2 focus:ring-nfblue/20" placeholder="First" data-id="element-312" data-mp="2gtf8gfvh80ww" />
                </div>
                <div data-id="element-313" data-mp="1x7izsnfcadck">
                  <label htmlFor="lastName" className="block text-sm font-bold text-slate-700" data-id="element-314" data-mp="1x4mxkmwgl2ib">
                    Last name <span className="text-red-500" data-id="element-315" data-mp="1t7ijex8ojs2v">*</span>
                  </label>
                  <input type="text" id="lastName" required className="mt-2 block w-full rounded-xl border border-slate-300 px-4 py-3 text-slate-900 placeholder-slate-400 focus:border-nfblue focus:outline-none focus:ring-2 focus:ring-nfblue/20" placeholder="Last" data-id="element-316" data-mp="38k39zt12b8b3" />
                </div>
              </div>

              <div className="grid gap-6 sm:grid-cols-2" data-id="element-317" data-mp="374r2rwnnq220">
                <div data-id="element-318" data-mp="37597zisarqm2">
                  <label htmlFor="email" className="block text-sm font-bold text-slate-700" data-id="element-319" data-mp="376ts0egzjr5o">
                    Email address <span className="text-red-500" data-id="element-320" data-mp="3uwo42tthdbov">*</span>
                  </label>
                  <input type="email" id="email" required className="mt-2 block w-full rounded-xl border border-slate-300 px-4 py-3 text-slate-900 placeholder-slate-400 focus:border-nfblue focus:outline-none focus:ring-2 focus:ring-nfblue/20" placeholder="email@example.com" data-id="element-321" data-mp="3n8zm2itxj7x" />
                </div>
                <div data-id="element-322" data-mp="mgcv7tfly656">
                  <label htmlFor="phone" className="block text-sm font-bold text-slate-700" data-id="element-323" data-mp="2uw439p65ri83">
                    Phone number <span className="text-red-500" data-id="element-324" data-mp="2pvygamau2jwc">*</span>
                  </label>
                  <input type="tel" id="phone" required className="mt-2 block w-full rounded-xl border border-slate-300 px-4 py-3 text-slate-900 placeholder-slate-400 focus:border-nfblue focus:outline-none focus:ring-2 focus:ring-nfblue/20" placeholder="(555) 555-5555" data-id="element-325" data-mp="2kx53yx7a8yxr" />
                </div>
              </div>

              <div data-id="element-326" data-mp="33v7oayovy7p8">
                <label htmlFor="address" className="block text-sm font-bold text-slate-700" data-id="element-327" data-mp="33uogwbwv31pg">
                  Service Address <span className="text-red-500" data-id="element-328" data-mp="2ywwgeti5i79n">*</span>
                </label>
                <input type="text" id="address" required className="mt-2 block w-full rounded-xl border border-slate-300 px-4 py-3 text-slate-900 placeholder-slate-400 focus:border-nfblue focus:outline-none focus:ring-2 focus:ring-nfblue/20" placeholder="1234 Main St, City, TX Zip" data-id="element-329" data-mp="7xt62zhgvnj" />
              </div>

              <div data-id="element-330" data-mp="cogqt8jn6zyu">
                <label className="block text-sm font-bold text-slate-700" data-id="element-331" data-mp="cs4moeck7ygq">
                  Service Requested <span className="text-red-500" data-id="element-332" data-mp="hms45t95bslt">*</span>
                </label>
                <div className="mt-3 grid gap-3 sm:grid-cols-3" data-id="element-333" data-mp="mnfzus8bkxmd">
                  {['Irrigation Repair', 'New Installation', 'Drainage / Other'].map(service => <label key={service} className="flex cursor-pointer items-center gap-3 rounded-xl border border-slate-200 p-4 transition-colors hover:bg-slate-50 has-[:checked]:border-nfblue has-[:checked]:bg-nfblue/5" data-id="element-334" data-mp="vfzw5m152q41">
                      <input type="checkbox" name="service" value={service} className="h-5 w-5 rounded border-slate-300 text-nfblue focus:ring-nfblue" data-id="element-335" data-mp="1ad0j7c8dxww6" />
                      <span className="text-sm font-medium text-slate-700" data-id="element-336" data-mp="uf7om81z4bp2">{service}</span>
                    </label>)}
                </div>
              </div>

              <div data-id="element-337" data-mp="pmeknmebx7e1">
                <label htmlFor="message" className="block text-sm font-bold text-slate-700" data-id="element-338" data-mp="13fw47770mk42">
                  Additional Information <span className="text-red-500" data-id="element-339" data-mp="yhb2t4g11ue1">*</span>
                </label>
                <p className="mt-1 text-xs text-slate-500" data-id="element-340" data-mp="1de23ri5cne5r">
                  Please provide any details about the issue and dates/times that work best for you.
                </p>
                <textarea id="message" required rows={4} className="mt-3 block w-full resize-none rounded-xl border border-slate-300 px-4 py-3 text-slate-900 placeholder-slate-400 focus:border-nfblue focus:outline-none focus:ring-2 focus:ring-nfblue/20" placeholder="Type your message here..." data-id="element-341" data-mp="18cw8pdo7vet2" />
              </div>

              <button type="submit" className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-nfgreen px-8 py-4 text-base font-bold text-white shadow-lg shadow-nfgreen/30 transition-transform hover:scale-[1.02] hover:bg-nfgreen-dark focus:outline-none focus:ring-2 focus:ring-nfgreen focus:ring-offset-2" data-id="element-342" data-mp="1fyhyvgqqvhtl">
                <SendIcon className="h-5 w-5" data-id="element-343" data-mp="1axaqbfgs2elv" />
                Send Request
              </button>
            </form>}
        </motion.div>
      </div>
    </section>;
}